"use client";

import React, { useEffect, useState } from 'react';
import classesData from '@/data/classes.json';
import { fallbackCourseNames } from '@/app/services/api';
import { formatBaseIdDisplay } from '@/app/lib/utils';
import { readableCourseTitle } from '@/app/lib/courseTitle';

interface CourseNameProps {
  code: string; // base id like 01198111 or format 01:198:111
  className?: string;
}

export const CourseName: React.FC<CourseNameProps> = ({ code, className }) => {
  const [label, setLabel] = useState<string>(code);
  const [fromCsv, setFromCsv] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true;
    const digits = String(code).replace(/\D/g, '');

    // 1) Try classes.json (offered data)
    const local = (classesData as any)[code]?.fullTitle || (classesData as any)[code]?.title
      || (classesData as any)[digits]?.fullTitle || (classesData as any)[digits]?.title;
    if (local) {
      setLabel(local);
      setFromCsv(false);
      return;
    }

    // 2) CSV fallback via API for non-offered courses
    (async () => {
      try {
        const res = await fallbackCourseNames.getName(code);
        if (isMounted && res.title) {
          setLabel(res.title);
          setFromCsv(true);
        } else if (isMounted) {
          setLabel(formatBaseIdDisplay(code));
          setFromCsv(false);
        }
      } catch {
        if (isMounted) {
          setLabel(formatBaseIdDisplay(code));
          setFromCsv(false);
        }
      }
    })();

    return () => { isMounted = false; };
  }, [code]);

  return (
    <span className={className} title={fromCsv ? 'Not offered this semester' : undefined}>
      {readableCourseTitle(label)}
    </span>
  );
};

export default CourseName;


